import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrganizationListComponent } from './components/organization/organization-list/organization-list.component';
import { OrganizationFormComponent } from './components/organization/organization-form/organization-form.component';
import { IntentListComponent } from './components/intent/intent-list/intent-list.component';
import { IntentFormComponent } from './components/intent/intent-form/intent-form.component';
import { OrganizationIntentComponent } from './components/organization-intent/organization-intent.component';
import { OrganizationTypeComponent } from './components/organization/organization-type/organization-type.component';

export const routes: Routes = [
    {
        path: '',
        canActivate: [MsalGuard],
        children: [
            { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent },

            { path: 'organizations', component: OrganizationListComponent },
            { path: 'organization/create', component: OrganizationFormComponent },
            { path: 'organizations/edit/:id', component: OrganizationFormComponent },
            { path: 'organization-types', component: OrganizationTypeComponent },

            { path: 'intents', component: IntentListComponent },
            { path: 'intent/create', component: IntentFormComponent },
            { path: 'intent/edit/:id', component: IntentFormComponent },

            { path: 'organization-intent', component: OrganizationIntentComponent }
        ]
    },
    { path: 'login-failed', component: LoginFailedComponent },
    { path: 'auth', component: MsalRedirectComponent }, // Redirect URI route
    { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },// Fallback for invalid paths
];
